/**
 * «Вход через вопрос» на главной: кнопки → вопрос хорара.
 *
 * Одна таблица на всё: кнопка на главной, тип вопроса хорара (question_type
 * бэкенда) и заголовок ответа. Когда Астролог сдаст отдельный вопрос
 * (например, «Вернётся ли он?»), меняется только поле type здесь — логика
 * главной и хорара не трогается.
 *
 *   label — надпись кнопки и заголовок ответа хорара;
 *   type  — question_type из INTERPRETERS (backend/routers/horary.py).
 */
export const QUESTION_BUTTONS = [
  { key: 'will_text', label: 'Он не пишет — напишет ли?', type: 'will-text' },
  { key: 'will_return', label: 'Вернётся ли он?', type: 'will-return' },
  { key: 'does_love', label: 'Любит ли он меня?', type: 'does-love' },
  { key: 'money_soon', label: 'Когда придут деньги?', type: 'money-soon' },
];

const BY_KEY = Object.fromEntries(QUESTION_BUTTONS.map((b) => [b.key, b]));

export function questionButtonByKey(key) {
  return BY_KEY[key] || null;
}

/** Адрес хорара, который сразу строит карту этого вопроса. */
export function horarUrlFor(button) {
  return `/horar?ask=${encodeURIComponent(button.key)}`;
}
